/*
 * @Author: ken yang
 * @Date: 2023-08-28 09:49:58
 * @LastEditTime: 2025-06-25 15:55:46
 * @LastEditors: ken yang
 * @Description: 请求域名
 * @FilePath: /uexch_pc/src/utils/url.js
 */
/**
 * 使用正则表达式提取主域名（更严格的方法）
 * @param {string} hostname - 完整的主机名
 * @returns {string} 主域名
 */
function getMainDomainByRegex (hostname) {
  if (!hostname) return ''

  // 匹配主域名的正则表达式
  const regex = /[^.]+\.[^.]+$/
  const match = hostname.match(regex)

  return match ? match[0] : hostname
}

const localhostDomain = ['localhost', '127.0.0.1']

/**
 * 获取主域名（去除二级域名前缀）
 * @param {string} hostname - 主机名
 * @returns {string} 主域名
 */
function getAgentMainDomain (hostname) {
  if (!hostname) return ''

  if (localhostDomain.includes(domain)) return import.meta.env.VITE_APP_DEFAULT_DOMAIN
  // 移除端口号（如果存在）
  const cleanHostname = hostname.split(':')[0]
  // 分割域名部分
  const parts = cleanHostname.split('.')
  // 如果只有一个部分或者是IP地址，直接返回
  if (parts.length <= 1 || /^\d+\.\d+\.\d+\.\d+$/.test(cleanHostname)) {
    return cleanHostname
  }
  // 如果是localhost等特殊域名，直接返回
  if (cleanHostname === 'localhost') {
    return cleanHostname
  }
  // 返回最后两个部分作为主域名（例如：test.example.com -> example.com）
  return parts.slice(-2).join('.')
}

// 在这里获取当前用户输入的域名 然后将域名替换到环境变量
let domain = window.location.hostname

let wsUrl = ''
let wsFuturesUrl = ''
let serveUrl = ''
let h5Url = ''

const replaceDomain = (template = '', targetDomain = domain, placeholder = '{domain}') =>
  String(template || '').replace(placeholder, targetDomain)

// 使用新的函数提取主域名
const agentMainDomain = getAgentMainDomain(domain)

// domain = mainDomain

if (localhostDomain.includes(domain)) domain = import.meta.env.VITE_APP_DEFAULT_DOMAIN // 为了方便本地模拟生产环境，本地域名是localhost 替换成国内生产环境域名
wsUrl = replaceDomain(import.meta.env.VITE_APP_WS_URL)
wsFuturesUrl = replaceDomain(import.meta.env.VITE_APP_WS_FUTURES_URL)
serveUrl = replaceDomain(import.meta.env.VITE_APP_BASE_URL)
h5Url = replaceDomain(import.meta.env.VITE_APP_H5_URL, agentMainDomain)

const agentDomain = replaceDomain(import.meta.env.VITE_APP_AGENT_DOMAIN, agentMainDomain, '{agentDomain}')
const bftLink = 'https://etherscan.io/token/0xedbf98724a86f92baefac101082c366e96f1e9d9'

export {
  wsUrl,
  wsFuturesUrl,
  serveUrl,
  h5Url,
  bftLink,
  agentDomain
}
